// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformSharedLogin = {
  summary:
    "プラットフォーム管理系ワークスペースは、まず統合認証の現在セッションを引き継いでから対象コントロールプレーンへ入ります。",
  bootstrapTitle: "統合認証セッションを確認しています",
  bootstrapDescription: "すでにポータルでログインしていれば、このページで現在の認証を検出します。",
  noSessionTitle: "利用可能な統合認証セッションが見つかりません",
  noSessionDescription:
    "先にポータルでログインし、その後このページに戻って現在のワークスペースへ進んでください。",
  portalAction: "ポータルでログイン",
  enterAction: "現在の認証で入る",
  switchIdentityAction: "認証を切り替える",
  redetectAction: "統合認証セッションを再確認",
} as const;
